/* tslint:disable */

/**
 * Inicializaión de la interfaz IBiocatchContextModel
 * 
 * *Set IBiocatchContextModel interface*
 * 
 * @access public
 * @type {interface}
 */
export interface IBiocatchContextModel {
    baseContext: IBaseContext;
    products: IProducts;
    step: IStep;
    types: ISolicitationTypes;
}

export interface IBaseContext {
    web: string;
    app: string;
    web_pre: string;
    app_pre: string;
    app_allies: string;
    app_allies2: string;
}

export interface IProducts {
    AHO: string;
    NOM: string;
    TCR: string;
    ORD: string;
    CRP: string;
    LOA: string;
}

export interface IStep {
    productos: string;
    solicitud: string;
    identificacion: string;
    captura: string;
    configuracion: string;
    vinculacion: string;
    oferta: string;
}

export interface ISolicitationTypes {
    AHO: string;
    NOM: string;
    TCR: string;
    ORD: string;
    CRP: string;
    LOA: string
}

/**
 * Clase que permite revisar y ajustar el JSON recibido del servicio
 * de Geolocalización en Biocatch
 */
export class ResponseBiocatchGeo {
    score: String = "";
    bcStatus: String = "";
    customerSessionID: String = "";
    isBot: String = "";;
    isRat: String = "";;
    requestTime: String = "";;
    muid: String = "";;
    ipGeoCountry: String = "";
    ipGeoCity: String = "";
    ipGeoASN: String = "";
    ipGeoLongtitude: String = "";
    ipGeoLatitude: String = "";
    behavioralData: any;
    ip: String = "";
    isMalware: boolean = false;
    riskLevel: String = "";
    riskFactors: any = {};
    integrated_score_rule: number = 0;
    reason_codes: any = {};
    altTab: number = 0;
    comboEvents: number = 0;
    ctrlTab: number = 0;
    ctrlV: number = 0;
    ctrlX: number = 0;
    cutClipboard: number = 0;
    pasteClipboard: number = 0;
    rule: String = "";
    ip_geo_country: String = "";
}





